const local = {
  API: {
    AUTH: 'https://localhost:44314/api',
    DATA: 'https://localhost:44314/api'
  }
}

const dev = {
  API: {
    AUTH: 'https://localhost:44314/api',
    DATA: 'https://localhost:44314/api'
  }
}

const uat = {
  API: {
        AUTH: 'https://<uat website address here>/api',
        DATA: 'https://<uat website address here>/api'
  }
}

const prod = {
  API: {
        AUTH: 'https://soltec-api.azurewebsites.net/api',
        DATA: 'https://soltec-api.azurewebsites.net/api'
  }
}


const config = process.env.REACT_APP_STAGE === 'prod' ? prod
  : process.env.REACT_APP_STAGE === 'uat' ? uat
    : process.env.REACT_APP_STAGE === 'dev' ? dev
      : local;

const API_URL = config.API.DATA;
const AUTH_URL = config.API.AUTH;

export { API_URL, AUTH_URL, config };
